import { Issue } from "@/stores/types";
import * as jose from "jose";

export const generateReadingToken = (issue: Issue) => {
  const authToken = process.env.REACT_APP_API_SECRETE;

  const payload = {
    publication: {
      id: issue.publicationId,
      name: issue.publicationName,
      publication_number: {
        id: issue.id,
        directory: issue.directory,
        count_pages: issue.countPages,
        ojd: issue.ojd,
      },
    },
    userData: {
      kiosk: process.env.REACT_APP_KIOSK_ID,
      key: authToken,
      apikey: authToken,
    },
    apiUrl: `${process.env.REACT_APP_API_URL}/api`,
  };

  const secret = new TextEncoder().encode(
    "MwqVAJmWdXjDzaUQZRrExkvhgTP9Gf5NbBpcKS8eLCuFnH2Yt7"
  );
  const alg = "HS256";
  return new jose.SignJWT(payload)
    .setProtectedHeader({ alg })
    .setIssuedAt()
    .setExpirationTime("1 hour")
    .sign(secret);
};
type ReadingReturnedValue = {
  readingUrl: string;
  token: string;
  cookieOptions: any;
};
export const prepareToRead = async (
  issue: Issue
): Promise<ReadingReturnedValue> => {
  const token = await generateReadingToken(issue);
  console.log({ token });

  return {
    readingUrl: `${process.env.REACT_APP_READER_URL}?publicationId=${issue.publicationId}&issueId=${issue.id}&token=${token}`,
    token: token,
    cookieOptions: {
      maxAge: 60 * 60, // 1 hour (en secondes)
      path: "/", // Accessible sur tout le site
      domain: ".kioskpress.fr", // Domaine partagé entre l'app et le site cible
      secure: true, // Requiert HTTPS
      sameSite: "lax", // Autorise l'envoi du cookie sur le domaine cible
    },
  };
};
